import {
  CreateButton,
  Datagrid,
  Filter,
  TextField,
  TextInput,
  useListContext,
} from "react-admin";
import flowApiClients from ".";
import { useResetListSearchField } from "../../../common/hooks/useResetListSearchField";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { IResourceListProps } from "../../common/ra-types";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";

interface Props extends IResourceListProps {}

const ListFilter = (props: any) => {
  useSearchFields(props, ["name"]);
  useResetListSearchField(props);
  const { loading } = useListContext();
  return (
    <Filter {...props}>
      {!loading && (
        <TextInput
          className="companies-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
          autoFocus
          autoComplete="off"
        />
      )}
      {loading && (
        <TextInput
          className="companies-list-filter search-box"
          label="resources.common.labels.search"
          source="q"
          alwaysOn
        />
      )}
    </Filter>
  );
};

const ListActions = () => {
  const { basePath } = useListContext();
  return <CreateButton basePath={basePath} />;
};

export const ApiClientsList = (props: Props) => {
  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={flowApiClients.icon} />}
        className="content-list"
        title="resources.admin-flow-api-clients.name"
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        pagination={false}
        {...props}
      >
        <Datagrid>
          <TextField
            source="name"
            label="resources.admin-flow-api-clients.labels.name"
          />
          <ActionsField hasShow={props.hasShow}>
            <DeleteRecordMenuItem />
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
